/**
 * 接口文档
 * https://shopline.yuque.com/docs/share/cf40c532-2bc7-48ad-bb5b-f7d9e2216fba?#
 */
export default {
  /** 创建组合商品 */
  createGroupGoods: '/api/sku-group/create',
  /** 更新组合商品 */
  updateGroupGoods: '/api/sku-group/update',
  /**查询组合商品列表 */
  searchGroupGoods: '/api/sku-group/search',
  /**查询组合商品详情 */
  getGroupGoodDetail: '/api/sku-group/get',
  /**上下架商品组 */
  updateGroupGoodsStatus: '/api/sku-group/status',
  /** 删除组合商品 */
  deleteGroupGoods: '/api/sku-group/delete',
}
